import { NavLink } from 'react-router-dom';
import { HeartPulse, ShieldCheck, UsersRound, WalletCards } from 'lucide-react';

const navItem =
  'flex items-center gap-3 rounded-lg px-4 py-3 text-sm font-semibold text-slate-600 transition hover:bg-[#eef7f4] hover:text-[#24463f] dark:text-slate-300 dark:hover:bg-white/10 dark:hover:text-white';

const active = 'bg-[#dcefe8] text-[#24463f] dark:bg-emerald-500/20 dark:text-white';

export default function Sidebar() {
  return (
    <aside className="hidden min-h-screen w-72 border-r border-slate-200 bg-white px-4 py-6 dark:border-white/10 dark:bg-slate-900 lg:block">
      <div className="mb-8 flex items-center gap-3 px-3">
        <span className="grid h-10 w-10 place-items-center rounded-lg bg-[#47615a] text-white">
          <HeartPulse className="h-5 w-5" />
        </span>
        <div>
          <p className="font-serif text-2xl font-semibold text-[#24463f] dark:text-white">MindCare</p>
          <p className="text-xs font-semibold uppercase text-slate-500">Therapy admin</p>
        </div>
      </div>

      <nav className="space-y-2">
        <NavLink to="/mindcare" className={({ isActive }) => `${navItem} ${isActive ? active : ''}`}>
          <ShieldCheck className="h-5 w-5" />
          Operations center
        </NavLink>
        <a href="#patients" className={navItem}>
          <UsersRound className="h-5 w-5" />
          Patients
        </a>
        <a href="#payments" className={navItem}>
          <WalletCards className="h-5 w-5" />
          Payments
        </a>
      </nav>
    </aside>
  );
}
